module.exports = __webpack_public_path__ + "vme.jpg?e0b6f38e9e6bf187dce4dda10859d004";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vme.jpg
// module id = 371
// module chunks = 0